import { Typography } from "components";
import Transactions from "../../../Transactions/TransactionsTable";
import TransactionSuccessRate from "./TransactionSuccessRate";
import TransactionTypeStats from "../../common/TransactionTypeStatistics";
import TransactionPerRegionAnalytics from "./TransactionPerRegionAnalytics";
import TransactionVolumeAnalytics from "../../common/TransactionVolumeAnalytics";
import TerminalRequests from "pages/admin/Terminals/TerminalRequests/AgentsRequests";

const PMOperationsTerminalDashboard = () => {
  return (
    <div>
      <div className="row">
        <div className="col-xs-12 col-md-7 mt-4">
          <Typography state="primary" variant="body2" className={"text-center"}>
            Top 10 Transacting Terminals per Transaction type
          </Typography>
          <TransactionVolumeAnalytics showMenu={false} />
        </div>
        <div className="col-xs-12 col-md-5  mt-4">
          <Typography state="primary" variant="body2" className={"text-center"}>
            Transaction Analytics per Region
          </Typography>
          <TransactionPerRegionAnalytics />
        </div>
        <div className="col-xs-12 col-md-6  mtop-4">
          {" "}
          <Typography state="primary" variant="body2" className={"text-center"}>
            Transaction Type Statistics
          </Typography>
          <TransactionTypeStats />
        </div>
        <div className="col-xs-12 col-md-6  mtop-4">
          {" "}
          <Typography state="primary" variant="body2" className={"text-center"}>
            Transaction Success Rate
          </Typography>
          <TransactionSuccessRate />
        </div>
      </div>
      <TerminalRequests size={5} />
      <div className="space-top-4">
        <Transactions />
      </div>
    </div>
  );
};

export default PMOperationsTerminalDashboard;
